import app from '../../admin/app';
import ExtensionLinkButton from './ExtensionLinkButton';
import Component from '../../common/Component';
import LinkButton from '../../common/components/LinkButton';
import SelectDropdown from '../../common/components/SelectDropdown';
import getCategorizedExtensions from '../utils/getCategorizedExtensions';
import ItemList from '../../common/utils/ItemList';
import Stream from '../../common/utils/Stream';
import Input from '../../common/components/Input';
import extractText from '../../common/utils/extractText';
export default class AdminNav extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.query = Stream('');
  }
  view() {
    return m(SelectDropdown, {
      className: "AdminNav App-titleControl AdminNav-Main",
      buttonClassName: "Button"
    }, this.items().toArray().concat(this.extensionItems().toArray()));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.scrollToActive();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.scrollToActive();
  }
  scrollToActive() {
    const children = $('.Dropdown-menu').children('.active');
    const nav = $('#admin-navigation');
    const time = app.previous.type ? 250 : 0;
    if (children.length > 0 && (children[0].offsetTop > nav.scrollTop() + nav.outerHeight() || children[0].offsetTop + children[0].offsetHeight < nav.scrollTop())) {
      nav.animate({
        scrollTop: children[0].offsetTop - nav.height() / 2
      }, time);
    }
  }

  /**
   * Build an item list of main links to show in the admin navigation.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();
    items.add('category-core', m("h4", {
      className: "ExtensionListTitle"
    }, app.translator.trans('core.admin.nav.categories.core')), 120);
    items.add('dashboard', m(LinkButton, {
      href: app.route('dashboard'),
      icon: "far fa-chart-bar",
      title: app.translator.trans('core.admin.nav.dashboard_title')
    }, app.translator.trans('core.admin.nav.dashboard_button')), 100);
    items.add('basics', m(LinkButton, {
      href: app.route('basics'),
      icon: "fas fa-pencil-alt",
      title: app.translator.trans('core.admin.nav.basics_title')
    }, app.translator.trans('core.admin.nav.basics_button')), 90);
    items.add('mail', m(LinkButton, {
      href: app.route('mail'),
      icon: "fas fa-envelope",
      title: app.translator.trans('core.admin.nav.email_title')
    }, app.translator.trans('core.admin.nav.email_button')), 80);
    items.add('permissions', m(LinkButton, {
      href: app.route('permissions'),
      icon: "fas fa-key",
      title: app.translator.trans('core.admin.nav.permissions_title')
    }, app.translator.trans('core.admin.nav.permissions_button')), 70);
    items.add('appearance', m(LinkButton, {
      href: app.route('appearance'),
      icon: "fas fa-paint-brush",
      title: app.translator.trans('core.admin.nav.appearance_title')
    }, app.translator.trans('core.admin.nav.appearance_button')), 60);
    items.add('userList', m(LinkButton, {
      href: app.route('users'),
      icon: "fas fa-users",
      title: app.translator.trans('core.admin.nav.userlist_title')
    }, app.translator.trans('core.admin.nav.userlist_button')), 50);
    if (app.data.settings.show_advanced_settings) {
      items.add('advanced', m(LinkButton, {
        href: app.route('advanced'),
        icon: "fas fa-cog",
        title: app.translator.trans('core.admin.nav.advanced_title')
      }, app.translator.trans('core.admin.nav.advanced_button')), 40);
    }
    items.add('search', m(Input, {
      type: "search",
      className: "SearchBar",
      stream: this.query,
      clearable: true,
      placeholder: extractText(app.translator.trans('core.admin.nav.search_placeholder'))
    }), 0);
    return items;
  }
  extensionItems() {
    const items = new ItemList();
    const categorizedExtensions = getCategorizedExtensions();
    const categories = app.extensionCategories;
    Object.keys(categorizedExtensions).map(category => {
      if (!this.query()) {
        items.add("category-".concat(category), m("h4", {
          className: "ExtensionListTitle"
        }, app.translator.trans("core.admin.nav.categories.".concat(category))), categories[category]);
      }
      categorizedExtensions[category].map(extension => {
        const query = this.query().toUpperCase();
        const title = extension.extra['flarum-extension'].title || '';
        const description = extension.description || '';
        const isAbandoned = extension.abandoned;
        const hasReplacement = typeof isAbandoned === 'string';
        if (!query || title.toUpperCase().includes(query) || description.toUpperCase().includes(query)) {
          items.add("extension-".concat(extension.id), m(ExtensionLinkButton, {
            href: app.route('extension', {
              id: extension.id
            }),
            extensionId: extension.id,
            className: "ExtensionNavButton",
            title: description
          }, title, isAbandoned && m("span", {
            className: "Badge Badge--".concat(hasReplacement ? 'danger' : 'warning')
          }, "!")), categories[category]);
        }
      });
    });
    return items;
  }
}
flarum.reg.add('core', 'admin/components/AdminNav', AdminNav);